import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  detalleSlice,
  expedienteSlice,
  menuSlice,
  modalSlice,
  notificacionSlice,
  OdpSlice,
  pagosSlice,
  prospectoSlice,
  sessionSlice,
  telefonosSlice
} from './slices';
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { encryptTransform } from 'redux-persist-transform-encrypt';

let arrayTransform = [];

if (process.env.REACT_APP_ENVIRONMENT == 'production') {
  arrayTransform = [
    encryptTransform({
      secretKey: 'keys',
      onError: function (error) {
        // Handle the error.
        console.log(error);
      }
    })
  ];
}

const persistConfig = {
  key: 'app-main',
  version: 1,
  storage,
  timeout: null,
  stateReconciler: autoMergeLevel2,
  debug: true,
  transforms: arrayTransform,
  blacklist: ['menu', 'modal', 'detalle', 'expediente', 'prospecto', 'telefonos', 'odp', 'pagos']
};

const reducers = combineReducers({
  session: sessionSlice.reducer,
  menu: menuSlice.reducer,
  modal: modalSlice.reducer,
  prospecto: prospectoSlice.reducer,
  detalle: detalleSlice.reducer,
  expediente: expedienteSlice.reducer,
  telefonos: telefonosSlice.reducer,
  odp: OdpSlice.reducer,
  notificacion: notificacionSlice.reducer,
  pagos: pagosSlice.reducer
});

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [PERSIST, FLUSH, REHYDRATE, PAUSE, PURGE, REGISTER]
      }
    })
});
